import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=4acea1c6&"
import script from "./preview.vue.ts?vue&type=script&lang=ts&"
export * from "./preview.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports